import { errorToastClassName, successToastClassName, appToast as toast } from "@/components/ui/baseUi/sonner"
import { type MediaItemFormType } from "@/modules/common/media/mediaFormTypes"
import { MediaType } from "@/modules/common/media/mediaTypes"
import { UserProfileEntity } from "@/modules/users/entities/usersEntity"
import { useUpdateUser } from "@/modules/users/hooks/useUpdateUser"
import { word } from "@modules/core/utils/i18n"
import { getAvatartValidationSchema } from "@modules/profile/myProfile/userAvatarFormikType"
import { LoggerType } from "@modules/utils/loggerUtils"
import { useFormik } from "formik"
import { useState } from "react"

export const useProfileAvatarFormik = (userDraft: UserProfileEntity) => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const { mutateAsync: updateUser } = useUpdateUser()
  const formik = useFormik<{ avatar: MediaItemFormType | null }>({
    initialValues: {
      avatar: userDraft.avatar
        ? {
            url: userDraft.avatar.url,
            key: userDraft.avatar.key ?? null,
            type: MediaType.S3_IMAGE,
            filename: null,
            isUploading: false,
            file: null,
          }
        : null,
    },
    validationSchema: getAvatartValidationSchema(),
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true)
        await updateUser({ imageKey: values.avatar?.key ?? undefined })
        toast.success(word("profile.page.toast.success"), {
          classNames: successToastClassName(),
        })
      } catch (e: unknown) {
        if (e instanceof Error) {
          console.error(LoggerType.Profile + "update profile", e)
          toast.error(word("global.error.label"), {
            description: e.message,
            classNames: errorToastClassName(),
          })
        } else {
          console.error(LoggerType.Profile + "update profile", e)
          toast.error(word("global.error.label"), {
            description: String(e),
            classNames: errorToastClassName(),
          })
        }
      } finally {
        setIsSubmitting(false)
      }
    },
  })

  return { formik, isSubmitting }
}
